export const i18nNs = "common:warehouse.txn_editor.";
